module.exports = __webpack_public_path__ + "img/vol04_cup02_cover03.140b2584.jpg";